// Generated by purs version 0.15.15
var buildNotFoundViewProps = function (input) {
    return {
        path: input.path,
        homeRoute: input.homeRoute,
        loginRoute: input.loginRoute
    };
};
export {
    buildNotFoundViewProps
};
//# sourceMappingURL=index.js.map
